<template>
  <form>
    <div id="card-element"></div>
    <StripeElements
      v-if="stripeLoaded"
      v-slot="{ elements }"
      ref="elms"
      :stripe-key="stripeKey"
      :instance-options="instanceOptions"
      :elements-options="elementsOptions"
    >
      <StripeElement
        type="payment"
        ref="card"
        :elements="elements"
        :options="cardOptions"
      />
    </StripeElements>
    <button type="button" class="mt-6 w-full bg-black text-white p-3 px-6" @click="pay">Betala</button>
  </form>
</template>

<script>
import { StripeElements, StripeElement } from 'vue-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { defineComponent, ref } from 'vue'
export default defineComponent({
  props: {
    clientSecret: String,
    amount: Number,
    order: Object
  },
  name: 'PaymentModule',
  components: {
    StripeElements,
    StripeElement
  },
  setup(props) {
    const card = ref({ value: {} })
    const stripeKey = ref('pk_live_51IIXyoBtNsYjURCryn3wxE7NsaC6fyEiF0jtjZm9aI1NabMQ1WMadXmft2upCfRWQ3ZS3asOjw67puEW7Bc1Vt1100ykgnbg8v')
    const stripeLoaded = ref(false)
    const instanceOptions = ref({
      mode: 'payment',
      currency: 'sek',
      locale: 'sv',
      amount: props.amount * 100
    })
    const elementsOptions = ref({
      clientSecret: props.clientSecret
    })
    const cardOptions = ref({
    })
    const pay = () => {
      elms.value.instance.confirmPayment({
          elements: elms.value.elements,
          confirmParams: {
              // Return URL where the customer should be redirected after the PaymentIntent is confirmed.
              return_url: 'https://www.bioaspen.se/kvitto/',
              payment_method_data: {
                billing_details: {
                  email: props.email,
                }
              }
          }
      })
      .then(function(result) {
        if (result.error) {
          alert( result.error.message );
        }
      })
      
    }
    const stripePromise = loadStripe(stripeKey.value)
    stripePromise.then(() => {
      stripeLoaded.value = true
    })
    const elms = ref(null)
    return {
      card,
      stripeKey,
      stripeLoaded,
      instanceOptions,
      elementsOptions,
      cardOptions,
      elms,
      pay
    }
  },
})
</script>

